import {EventEmitter, Injectable} from '@angular/core';
import {AzureService} from './azure.service';
import {ElectronService} from '../electron/electron.service';
import {IPC} from '../../constants/shared.constants';
import {AzureSignInData} from '../../models/azure-sign-in-data.model';
import {SignInData} from '../../models/msal/sign-in-data.model';
import {AzureSignInMethodEnum} from '../../enums/azure-sign-in-method.enum';

@Injectable({
    providedIn: 'root'
})
export class AzureElectronService implements AzureService {
    public readonly onSignIn = new EventEmitter<SignInData>(true);
    public readonly onSilentSignIn = new EventEmitter<SignInData | undefined>(true);
    public readonly onSignInFailure = new EventEmitter<AzureSignInMethodEnum>(true);

    public async setup(): Promise<void> {
        // The setup method is not needed for electron. It needs to be implemented due to the AzureService interface though and will therefore stay empty.
    }

    public login(): Promise<void> {
        ElectronService.ipcRender?.invoke<AzureSignInData | void, void>(IPC.AZURE.LOGIN)
            .then((signInData: AzureSignInData | void) => {
                if (signInData) {
                    this.onSignIn.emit({
                        username: signInData.tenantId,
                        password: signInData.idToken
                    });
                } else {
                    this.onSignInFailure.emit(AzureSignInMethodEnum.None);
                }
            })
            .catch(() => {
                this.onSignInFailure.emit(AzureSignInMethodEnum.Redirect);
            });
        return Promise.resolve();
    }

    public async logout(): Promise<void> {
        return ElectronService.ipcRender?.invoke<void, void>(IPC.AZURE.LOGOUT);
    }

    public async tryToReLogin(): Promise<boolean> {
        return ElectronService.ipcRender?.invoke<AzureSignInData | undefined, void>(IPC.AZURE.SILENT_LOGIN)
            .then(signInData => {
                if (signInData) {
                    this.onSilentSignIn.emit({
                        username: signInData.tenantId,
                        password: signInData.idToken
                    });
                }
                return !!signInData;
            })
            .catch(() => false) as Promise<boolean>;
    }
}
